import { BasketItem } from '@shared/services/cart/api-basket.service';

export class ShoppingCart {
  createdAt: Date;
  updatedAt?: Date;
  basketItems?: BasketItem[] = [];
  userId: number;
  id: number;

  constructor(cart: Partial<ShoppingCart>) {
    Object.assign(this, cart);
  }

  get itemsCount(): number | null {
    return this.basketItems?.length > 0
      ? this.basketItems.reduce((a, b) => a + b.quantity, 0)
      : null;
  }
}
